module.exports = __webpack_public_path__ + "static/media/184-sweden.61d447c4.svg";